import {select, put} from 'redux-saga/effects';
import {navigate} from '@reach/router';
import {PayloadAction} from '@reduxjs/toolkit';
import {RootState} from "../../store/rootReducer";
import {CardIdPayload, reviewActions} from "../review.slice";

export function* initializeSaga(action: PayloadAction<CardIdPayload>) {
    const urlCardId = action.payload?.cardId;
    const reduxCardId: string|undefined = yield select((state: RootState) => state.review.cardId);

    if (urlCardId !== undefined) {
        // The URL points at a specific card (e.g. opened/refreshed on /review/:cardId).
        // Load it unless we're already showing it (guard keeps our own navigations idempotent).
        if (urlCardId !== reduxCardId) {
            yield put(reviewActions.loadNext(urlCardId));
        }
        return;
    }

    if (reduxCardId === undefined) {
        yield put(reviewActions.loadNext());
    } else {
        // No id in the URL but a card is already in progress — reflect it in the URL.
        navigate(`/review/${reduxCardId}`, {replace: true});
    }
}
